import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalStockAssignmentComponent } from 'src/app/components/modals/modal-stock-assignment.component';
import { StockAssignment } from 'src/app/models/stock-assignment';
import { InventoryService } from 'src/app/services/inventory.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-index-stock-assignments',
  template: `
    <div class="d-flex mb-4 mt-4">
      <h1>Inventario</h1>
    </div>
    <div class="d-flex">
      <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
        <ul #sidebar app-nav-inventory [currentView]="currentView" class="list-unstyled"></ul>
      </div>
      <div class="flex-fill">
        <div class="content-section">
        <!-- Loading State -->
        <div *ngIf="loading" class="loading-container">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <p class="loading-text">Cargando inventario asignado...</p>
        </div>

        <div class="d-flex mt-2">
          <div class="flex-fill">
            <div class="d-flex justify-content-between mb-3">
              <div>
                <button type="button" class="btn btn-zazz-dark text-end" (click)="createAssignment()">
                  <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>Nueva asignación
                </button>
              </div>
            </div>

            <div class="list-group rounded-5 shadow mt-4" >
              <div class="list-group-item w-100" >
                <table class="table table-sm mt-3" style="overflow-x: scroll;">
                  <thead class="thead-dark">
                    <tr class="">
                      <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3"># Asignado <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                      <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">SKU</th>
                      <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Descripción</th>
                      <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Cantidad</th>
                      <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Asignado</th>
                      <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Estatus</th>
                      <th scope="col" class="text-center bg-zazz align-items-center align-middle text-light py-2">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let assignment of assignments">
                      <td class="user-name">{{ assignment.attributes?.user.name }} {{ assignment.attributes?.user.email }}</td>
                      <td class="item-code">{{ assignment.attributes?.stock.sku }}</td>
                      <td class="item-name">{{ assignment.attributes?.stock.name }}</td>
                      <td class="quantity-badge">{{ assignment.attributes?.quantity }}</td>
                      <td class="assigned-date">{{ assignment.attributes.created_at | date:'short' }}</td>
                      <td>
                        <span 
                          class="status-badge"
                          [ngClass]="{
                            'status-active': assignment.attributes?.status === 'active',
                            'status-returned': assignment.attributes?.status === 'returned',
                            'status-damaged': assignment.attributes?.status === 'damaged'
                          }"
                        >
                          {{ assignment.attributes?.status | titlecase }}
                        </span>
                      </td>
                      <td>
                        <div class="assignment-actions">
                          <div class="btn-group" role="group">
                            <button 
                              type="button" 
                              class="btn btn-sm btn-outline-info"
                              (click)="viewAssignment(assignment)"
                              title="View Details"
                            >
                              <fa-icon [icon]="icons.faEye"></fa-icon>
                            </button>
                            <button 
                              type="button" 
                              class="btn btn-sm btn-outline-primary"
                              (click)="editAssignment(assignment)"
                              title="Edit Assignment"
                            >
                              <fa-icon [icon]="icons.faEdit"></fa-icon>
                            </button>
                            <button 
                              type="button" 
                              class="btn btn-sm btn-outline-success"
                              (click)="returnItem(assignment)"
                              title="Mark as Returned"
                            >
                              <fa-icon [icon]="icons.faUser"></fa-icon>
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="assignments.length === 0" class="text-center bg-light empty-state py-3">
                <div class="empty-icon">
                  <i class="fas fa-clipboard-list"></i>
                </div>
                <h4 class="text-center">No se encontraron registros</h4>
                <p class="text-sm">No hay asignaciones con el filtro seleccionado</p>
                <button type="button" class="btn btn-zazz-dark" (click)="createAssignment()">
                  Crear asignación
                </button>
              </div>
          </div>

        <!-- Assignments List -->
        <div *ngIf="!loading" class="assignments-container">
          <div class="assignments-grid">
            
          </div>

          <!-- Empty State -->
          
        </div>

        <!-- Pagination -->
        <div *ngIf="pagination.totalPages > 1" class="pagination-section">
          <nav aria-label="Stock assignments pagination">
            <ul class="pagination justify-content-center">
              <li class="page-item" [class.disabled]="pagination.currentPage === 1">
                <a class="page-link" href="#" (click)="goToPage(1, $event)">First</a>
              </li>
              <li class="page-item" [class.disabled]="pagination.currentPage === 1">
                <a class="page-link" href="#" (click)="goToPage(pagination.currentPage - 1, $event)">Previous</a>
              </li>
              
              <li 
                *ngFor="let page of getVisiblePages()" 
                class="page-item" 
                [class.active]="page === pagination.currentPage"
              >
                <a class="page-link" href="#" (click)="goToPage(page, $event)">{{ page }}</a>
              </li>
              
              <li class="page-item" [class.disabled]="pagination.currentPage === pagination.totalPages">
                <a class="page-link" href="#" (click)="goToPage(pagination.currentPage + 1, $event)">Next</a>
              </li>
              <li class="page-item" [class.disabled]="pagination.currentPage === pagination.totalPages">
                <a class="page-link" href="#" (click)="goToPage(pagination.totalPages, $event)">Last</a>
              </li>
            </ul>
          </nav>

          <div class="pagination-info">
            <span class="info-text">
              Mostrando {{ getStartItem() }} to {{ getEndItem() }} of {{ pagination.totalItems }} assignments
            </span>
          </div>
        </div>
      </div>
      </div>
    </div>
    <app-modal-stock-assignment
      (assignmentCreated)="onAssignmentCreated($event)"
      (assignmentUpdated)="onAssignmentUpdated($event)"
      (updateDismiss)="onModalDismiss()"
    ></app-modal-stock-assignment>
  `,
  styles: `
    .status-active {
      background-color: #d4edda;
      color: #155724;
    }

    .status-returned {
      background-color: #fff3cd;
      color: #856404;
    }

    .status-damaged {
      background-color: #f8d7da;
      color: #721c24;
    }
  `
})
export class IndexStockAssignmentsComponent implements OnInit {
  assignments: any = []; // StockAssignment[] = [];
  loading: boolean = false;
  searchTerm: string = '';
  statusFilter: string = '';
  pagination = {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10
  }

  currentView: string = 'stock-assignments';

  @ViewChild(ModalStockAssignmentComponent, { static: true }) modalStockAssignment!: ModalStockAssignmentComponent;
  
  constructor(
    private inventoryService: InventoryService,
    public icons: IconsService
  ) {}

  ngOnInit(): void {
    this.loadAssignments();
  }

  loadAssignments(): void {
    this.loading = true;
    
    const params = {
      search: this.searchTerm,
      status: this.statusFilter
    };

    this.inventoryService.getStockAssignments(params).subscribe({
      next: (response: any) => {
        this.assignments = response.data;
        // this.pagination = {
          // currentPage: response.currentPage,
          // totalPages: response.totalPages,
          // totalItems: response.totalItems,
          // itemsPerPage: response.itemsPerPage
        // };
        this.loading = false;
      },
      error: (error: any) => {
        console.error('Error loading stock assignments:', error);
        this.loading = false;
      }
    });
  }

  onSearch(): void {
    this.pagination.currentPage = 1;
    this.loadAssignments();
  }

  onFilterChange(): void {
    this.pagination.currentPage = 1;
    this.loadAssignments();
  }

  onPageSizeChange(): void {
    this.pagination.currentPage = 1;
    this.loadAssignments();
  }

  goToPage(page: number, event: Event): void {
    event.preventDefault();
    if (page >= 1 && page <= this.pagination.totalPages) {
      this.pagination.currentPage = page;
      this.loadAssignments();
    }
  }

  getVisiblePages(): number[] {
    const totalPages = this.pagination.totalPages;
    const currentPage = this.pagination.currentPage;
    const delta = 2;
    
    const range = [];
    const rangeWithDots = [];
    
    for (let i = Math.max(2, currentPage - delta); 
         i <= Math.min(totalPages - 1, currentPage + delta); 
         i++) {
      range.push(i);
    }
    
    if (currentPage - delta > 2) {
      rangeWithDots.push(1, '...');
    } else {
      rangeWithDots.push(1);
    }
    
    rangeWithDots.push(...range);
    
    if (currentPage + delta < totalPages - 1) {
      rangeWithDots.push('...', totalPages);
    } else {
      rangeWithDots.push(totalPages);
    }
    
    return rangeWithDots.filter(page => typeof page === 'number') as number[];
  }

  getStartItem(): number {
    return (this.pagination.currentPage - 1) * this.pagination.itemsPerPage + 1;
  }

  getEndItem(): number {
    return Math.min(
      this.pagination.currentPage * this.pagination.itemsPerPage,
      this.pagination.totalItems
    );
  }

  createAssignment(): void {
    // Navigate to create assignment page
    console.log('Create new assignment');
    const modalTemplate: any | undefined = this.modalStockAssignment;
    console.log('modalTemplate:', modalTemplate);
    if (modalTemplate) {
      modalTemplate.openModal(modalTemplate['modalStockAssignment']);
    }
  }

  viewAssignment(assignment: StockAssignment): void {
    // Navigate to view assignment details
    console.log('View assignment:', assignment);
    
  }

  // Add event handlers for modal events
  onAssignmentCreated(assignment: any): void {
    console.log('Assignment created:', assignment);
    this.loadAssignments(); // Refresh the list
  }

  onAssignmentUpdated(assignment: any): void {
    console.log('Assignment updated:', assignment);
    this.loadAssignments(); // Refresh the list
  }

  onModalDismiss(): void {
    console.log('Modal dismissed');
    // Any cleanup if needed
  }

  editAssignment(assignment: any): void {
    console.log('Edit assignment:', assignment);
    
    // Transform the assignment data to match the StockAssignment interface
    const assignmentData = {
      id: assignment.id,
      user: {
        id: assignment.attributes?.user?.id,
        name: assignment.attributes?.user?.name,
        email: assignment.attributes?.user?.email,
        department: assignment.attributes?.user?.department
      },
      item: {
        id: assignment.attributes?.stock?.id,
        name: assignment.attributes?.stock?.name,
        code: assignment.attributes?.stock?.sku,
        category: assignment.attributes?.stock?.categories
      },
      quantity: assignment.attributes?.quantity,
      assignedDate: new Date(assignment.attributes?.created_at),
      status: assignment.attributes?.status,
      notes: assignment.attributes?.notes
    };

    const modalTemplate: any | undefined = this.modalStockAssignment;
    if (modalTemplate) {
      // Pass the assignment data to the modal for editing
      modalTemplate.openModal(modalTemplate['modalStockAssignment'], assignmentData);
    }
  }

  returnItem(assignment: any): void {
    console.log('Return item:', assignment.attributes?.stock?.name);
    if (confirm(`Mark item "${assignment.attributes?.stock?.name}" as returned?`)) {
      this.inventoryService.returnStockAssignment(assignment.id, { stock_id: assignment.attributes?.stock?.id }).subscribe({
        next: () => {
          this.loadAssignments();
        },
        error: (error) => {
          console.error('Error returning item:', error);
        }
      });
    }
  }

}
